import React from "react";
import { Link } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import { FaPencilAlt } from "react-icons/fa";

import "./styles/Customer.css";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

import PanelLayout from "../components/PanelLayout";
import { ListSkeleton } from "../components/Skeleton";
import * as actions from "../redux/actions/customerActions";

function displayValue(value) {
  if (value == null) return "—";
  const text = String(value).trim();
  return text || "—";
}

function MetaRow({ label, value }) {
  const display = displayValue(value);
  const isEmpty = display === "—";

  return (
    <div className="customer-page__meta-row">
      <dt>{label}</dt>
      <dd className={isEmpty ? "customer-page__meta-value--empty" : undefined}>
        {display}
      </dd>
    </div>
  );
}

class Customer extends React.Component {
  componentDidMount() {
    this.fetchCustomer();
  }

  fetchCustomer = async () => {
    try {
      await this.props
        .LoadCustomer(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { customer, loading } = this.props;

    return (
      <PanelLayout>
        <div className="customer-page">
          <header className="customer-page__header">
            <h1 className="customer-page__title">
              <Translate value="billing" />
            </h1>
            <Link to="/customer/edit" className="customer-page__edit-btn">
              <FaPencilAlt />
              <Translate value="profile_edit" />
            </Link>
          </header>

          {loading ? (
            <div className="customer-page__loading">
              <ListSkeleton />
            </div>
          ) : (
            <div className="customer-page__grid">
              <section className="customer-page__card">
                <h2 className="customer-page__card-title">
                  <Translate value="billing_customer_data" />
                </h2>
                <dl className="customer-page__meta">
                  <MetaRow
                    label={<Translate value="profile_name" />}
                    value={customer.Name}
                  />
                  <MetaRow
                    label={<Translate value="profile_email" />}
                    value={customer.Email}
                  />
                  <MetaRow
                    label={<Translate value="profile_phone" />}
                    value={customer.Phone}
                  />
                  <MetaRow
                    label={<Translate value="profile_organization" />}
                    value={customer.Organization}
                  />
                </dl>
              </section>
            </div>
          )}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,

    customer: reducer.customer.item || {},
    error: reducer.customer.error,
    loading: reducer.customer.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadCustomer: (user_id, token) =>
    dispatch(actions.loadItem({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Customer);
